var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgModalReferecniasOts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272,
    height: 122,
    viewBox: "0 0 272 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-583 -559)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2630 -9184)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1919 9763)",
    fill: "#efdbff",
    stroke: "#391085",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "2 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-1895 9791)",
    fill: "#391085",
    fontSize: 10,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.137,
    y: 0
  }, "MU")), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-1897 9813)",
    fill: "#391085"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2604 -9184)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1829 9755)",
    fill: "#efdbff",
    stroke: "#391085",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "2 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-1801 9787)",
    fill: "#391085",
    fontSize: 10,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.137,
    y: 0
  }, "MU")), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-1803 9813)",
    fill: "#391085"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2670 -9184)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-2049 9813)",
    fill: "#391085"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2063 9779)",
    fill: "#efdbff",
    stroke: "#391085",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "2 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-2047 9799)",
    fill: "#391085",
    fontSize: 10,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.137,
    y: 0
  }, "MU"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2649 -9184)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-1976 9813)",
    fill: "#391085"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1994 9771)",
    fill: "#efdbff",
    stroke: "#391085",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "2 4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-1974 9795)",
    fill: "#391085",
    fontSize: 10,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.137,
    y: 0
  }, "MU"))), /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 2,
    rx: 1,
    transform: "translate(623 656)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(611 645)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(791 645)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(616 650)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.953,0H.109A.11.11,0,0,0,0,.109V.93a.11.11,0,0,0,.109.109H9.953A.11.11,0,0,0,10.063.93V.109A.11.11,0,0,0,9.953,0Z",
    transform: "translate(1.969 6.48)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(796 650)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.109,0H.93a.1.1,0,0,1,.109.109V9.734a.1.1,0,0,1-.109.109H.109A.1.1,0,0,1,0,9.734V.109A.1.1,0,0,1,.109,0Z",
    transform: "translate(6.48 2.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.109,0H9.3a.1.1,0,0,1,.109.109V.93a.1.1,0,0,1-.109.109H.109A.1.1,0,0,1,0,.93V.109A.1.1,0,0,1,.109,0Z",
    transform: "translate(2.297 6.48)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 122,
    transform: "translate(583 559)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgModalReferecniasOts);
export default __webpack_public_path__ + "static/media/SVG-ModalReferecnias-OTS.1b32424d.svg";
export { ForwardRef as ReactComponent };